export default "__VITE_ASSET__C9l7KVed__"